import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAssetExposure = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.25 1.25H15.75V12.2677L19.2587 18.7501H6.16602L7.72222 15.75H1.5V14.25H8.5V14.2506L9.27839 12.75H2.25V1.25ZM14.25 2.75V9.4965L12.5731 6.39844L10.0565 11.25H3.75V2.75H14.25ZM12.6013 9.60168L8.6339 17.2501H16.7412L12.6013 9.60168ZM11.9498 14.5635V11.8362H13.4498V14.5635H11.9498ZM13.5741 15.9999C13.5741 16.497 13.1827 16.8999 12.6998 16.8999C12.2169 16.8999 11.8255 16.497 11.8255 15.9999C11.8255 15.5029 12.2169 15.0999 12.6998 15.0999C13.1827 15.0999 13.5741 15.5029 13.5741 15.9999Z",
		fill: "#90919C"
	})
});
export default SvgAssetExposure;
